import { itemDef } from "./items.ts";
import { RECIPES, type Recipe } from "./recipes.ts";

/** Estações que processam com o tempo (doc 03): Forno de Barro e Panela de Barro. */
export type ProcessStation = "forno" | "panela";

/**
 * Slots de cada estação, na ordem do schema: 0 = combustível, depois as entradas, por último a
 * saída. O Forno tem 1 entrada; a Panela, 4 (doc 03).
 */
export const STATION_INPUTS: Record<ProcessStation, number> = { forno: 1, panela: 4 };
export const stationSlotCount = (kind: ProcessStation): number => STATION_INPUTS[kind] + 2;
export const FUEL_SLOT = 0;
export const outputSlot = (kind: ProcessStation): number => STATION_INPUTS[kind] + 1;

/** Quem vê e mexe na estação: a até 5 m (doc 03, Armazenamento compartilhado). */
export const STATION_OPEN_RADIUS = 5;

/** Item que, posicionado, é uma estação de processo. */
export const PROCESS_STATION_ITEMS: Record<string, ProcessStation> = { "forno-barro": "forno", "panela-barro": "panela" };

/** Combustível do item em segundos de fogo e ritmo (doc 03: Palha 3 s, Madeira 12 s, Madeira de Lei 18 s, Carvão 36 s a ×1,25). */
export function fuelOf(itemId: string): { seconds: number; rate: number } | undefined {
  return itemId ? itemDef(itemId)?.fuel : undefined;
}

export interface StackView {
  itemId: string;
  qty: number;
}

/**
 * Receita que as entradas pedem agora. Forno: o item da entrada, com a quantidade mínima. Panela:
 * multiconjunto — os tipos nas entradas são exatamente os da receita (em qualquer ordem e
 * distribuição), cada um com pelo menos a quantidade pedida (doc 03).
 */
export function processRecipe(kind: ProcessStation, inputs: readonly StackView[]): Recipe | undefined {
  const totals = new Map<string, number>();
  for (const s of inputs) if (s.itemId && s.qty > 0) totals.set(s.itemId, (totals.get(s.itemId) ?? 0) + s.qty);
  if (totals.size === 0) return undefined;
  return RECIPES.find((r) => {
    if (r.station !== kind || r.inputs.length !== totals.size) return false;
    return r.inputs.every((i) => (totals.get(i.item) ?? 0) >= i.qty);
  });
}

/** Receitas de processo da estação (o livro de receitas da Panela mostra as conhecidas). */
export const stationRecipes = (kind: ProcessStation): Recipe[] => RECIPES.filter((r) => r.station === kind);
